import { Injectable } from '@angular/core';

import { Constants } from '../shared/constants';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class MotorService {

  constructor(private apiService: ApiService) { }
  async paymentBreakin(payload: any) {
    return await this.apiService.post(Constants.API_URL_PAYMENT_SUBMIT, payload)
      .toPromise()
      .catch(this.apiService.handleError('paymentBreakin', []));
  }

}
